import styled from 'styled-components';

import { Text, Title } from '@atom/typography/typography';

export const TitleStat = styled(Text).attrs((props) => ({
  color: props.theme.Title.colorConsumerCardTitle,
}))``;

export const Value = styled(Title).attrs({
  weight: 400,
  level: 4,
})`
  color: ${(props) => props.theme.Title.colorConsumerCardValue};
`;
